import { Button, Group, IconPlaceholder, Modal } from "@veneer/core";
import { useState } from "react";
import { HpLogo } from "../../shared-components/hp-logo/hp-logo";
import { Col, Container, Row } from "react-bootstrap";
import { PopupFooter } from "../../shared-components/modal-popup/popup-footer";
import { useTranslation } from "react-i18next";

interface ModalProps {
  show: boolean;
  profileData: any;
  onClose: () => void;
}

export const ViewProfile: React.FC<ModalProps> = ({
  onClose,
  show,
  profileData,
}) => {
  const {t} = useTranslation();
  const viewProfileData = profileData ? profileData[0] : "";
  return (
    <div style={{ position: "relative" }}>
      <Modal
        align="start"
        closeButton
        className="profile-view-popup"
        id="Profile-View"
        show={show}
        onClose={onClose}
        header={
          <div className="popup-header">
            <HpLogo />
            <h4>{t('HPI.Profilepage.myprofile.Viewprofile',{defaultValue:'View Profile'})}</h4>
          </div>
        }
      >
        <div className="profile-view-body">
          <h6 className="subtitle-regular">{t('HPI.createcase.contactequipment',{defaultValue:'Contact'})}</h6>
          <Container className="content">
            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.firstname',{defaultValue:'First name:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData?.firstname}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Lastname',{defaultValue:'Last name:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData?.lastname}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Phonenumber(main)',{defaultValue:'Phone number (main):'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData?.phNum}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.alterphonenumber',{defaultValue:'Phone number (alternate):'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData?.phNumAlternative}</p>
              </Col>
            </Row>
            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Email',{defaultValue:'Email:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData?.email}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Accountname',{defaultValue:'Account name:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData?.companyName}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.CreateCase.Pin',{defaultValue:'Pin:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData?.pinId}</p>
              </Col>
            </Row>
            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Timezone',{defaultValue:'Time zone:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.timezonename}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Preferredlanguage',{defaultValue:'Preferred language:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.languageName}</p>
              </Col>
            </Row>

            <Row className="inner-content mt-5">
              <Col>
                <h6 className="subtitle-regular">{t('HPI.Profilepage.myprofile.Address',{defaultValue:'Address'})}</h6>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Mailstop',{defaultValue:'Mail stop:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.mailstop}</p>
              </Col>
            </Row>
            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Contactphone',{defaultValue:'Contact phone:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.phNumAlternative}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Address',{defaultValue:'Address:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.addressline1}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.Citytown',{defaultValue:'City/Town:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.phCity}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.StateProvince',{defaultValue:'State/Province:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.phState}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.ZipPostalcode',{defaultValue:'Zip/Postal code:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.phZipcode}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col col={12} md={5}>
                <label>{t('HPI.Profilepage.ViewProfileModal.CountryRegion',{defaultValue:'Country:'})}</label>
              </Col>
              <Col col={12} md={7}>
                <p>{viewProfileData.countryName}</p>
              </Col>
            </Row>

            <Row className="inner-content">
              <Col className="d-flex justify-content-end">
                <Button onClick={onClose}>{t('HPI.Profilepage.ViewProfileModal.Edit',{defaultValue:'Edit'})}</Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </div>
  );
};
